import { formatToTitleCase } from './format-to-title-case';

import { SchedulesSearchPartner } from '@/types/professional/professional.type';
import { PhysicalUnit, PhysicalUnitAddress } from '@/app/(main)/(pages)/(home)/_types';

export const partnerBranchDisplayName = (partner: SchedulesSearchPartner | undefined): string => {
  if (!partner) {
    return '';
  }

  return partner.facility?.name
    ? `${formatToTitleCase(partner.socialName)} - ${formatToTitleCase(partner.facility.name)}`
    : `${formatToTitleCase(partner.socialName)}`;
};

export const formatBranchAddress = (address: PhysicalUnitAddress): string => {
  return `${formatToTitleCase(address.logradouro)}, ${address.number}, ${formatToTitleCase(address.district)}, ${
    address.city
  }, ${address.uf}, ${address.cep}`;
};

export function formatBranchTitle(unit: PhysicalUnit): string {
  return `${formatToTitleCase(unit.name, { keepAcronyms: true })} - ${formatToTitleCase(unit.address.district)}`;
}

export function formatBranchName(branchName: string): string {
  return `Unidade Física Medprev ${formatToTitleCase(branchName, { keepAcronyms: true })}`;
}
